import React, { useEffect, useState } from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

// tremor
import { Title as TremorTitle, Subtitle, Flex } from '@tremor/react';

// custom components
import { CheckBox } from '_atoms';

// styling
import { Colors, Spacing } from '_styles';

// icons
import { IoEarth } from "react-icons/io5";

const CountrySelector = (props) => {

    const [checkedCountries, setCheckedCountries] = useState([]);

    const countries = [
        'Albania',
        'Andorra',
        'Armenia',
        'Austria',
        'Azerbaijan',
        'Belarus',
        'Belgium',
        'Bulgaria',
        'Croatia',
        'Cyprus',
        'Czech Republic',
        'Denmark',
        'Estonia',
        'Finland',
        'France',
        'Georgia',
        'Germany',
        'Greece',
        'Hungary',
        'Iceland',
        'Ireland',
        'Italy',
        'Kazakhstan',
        'Kosovo',
        'Latvia',
        'Liechtenstein',
        'Lithuania',
        'Luxembourg',
        'Malta',
        'Moldova',
        'Monaco',
        'Montenegro',
        'Netherlands',
        'Norway',
        'Poland',
        'Portugal',
        'Romania',
        'Russia',
        'San Marino',
        'Serbia',
        'Slovakia',
        'Slovenia',
        'Spain',
        'Sweden',
        'Switzerland',
        'Turkey',
        'Ukraine',
        'United Kingdom (UK)',
    ];

    const handleCheckList = (country) => {
        if (checkedCountries.includes(country)) {
            // remove from list
            let temp = checkedCountries.filter(item => item !== country);
            setCheckedCountries(temp)
        }
        else {
            // add to list
            let temp = [...checkedCountries];
            temp.push(country)
            setCheckedCountries(temp);
        }
    }

    const checkEurope = (checked) => {
        if (checkedCountries.length == 51) {
            setCheckedCountries([]);
        } else {
            setCheckedCountries(countries)
        }
    }

    return (
        <Container>
            <Row>
                {/* Title + Select All Filter */}
                <Flex>
                    <Container className='mt-3'>
                        <IoEarth size={80} color={Colors.PRM_LIGHT_BLUE} />
                        <h4 className='mt-2'>Country or Region Availability</h4>
                        <Subtitle>Select the countries your product is deliverable to</Subtitle>
                    </Container>
                </Flex>
            </Row>

            <Container>
                <hr style={{ color: Colors.PRM_LIGHT_BLUE }} />
            </Container>

            <Row style={{ marginLeft: Spacing.SCALE_12 }}>

                <TremorTitle>{"Europe (49 Countries)"}</TremorTitle>

                <Row style={{ marginLeft: Spacing.SCALE_4, marginTop: Spacing.SCALE_4, padding: 8 }}>
                    {countries.map((country, index) => {
                        return (
                            <Col key={index} xs={6} md={3}>
                                <CheckBox handleButtonClick={() => { handleCheckList(country) }} data={checkedCountries}>{country}</CheckBox>
                            </Col>
                        )
                    })}
                </Row>
            </Row>

            <Container>
                <hr style={{ color: Colors.PRM_LIGHT_BLUE }} />
            </Container>

            <Container style={{ marginBottom: 22 }}>
                <Flex>
                    <Button onClick={props.cancel} variant={'outline-primary'}>Cancel</Button>
                    <Button onClick={() => { props.done(checkedCountries) }} variant={'outline-primary'}>Done</Button>
                </Flex>
            </Container>

        </Container>
    );
};

export default CountrySelector;
